<template>
  <!-- signature -->
  <div class="zwx-signature" v-show="false">
    <zwx-ipc ref="wsSignatureRef" @message="wsSignature" @connect="connect"></zwx-ipc>
  </div>
</template>

<script>
export default {
  name: 'ZwxSignature',
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    // socket连接状态
    connect(connect) {
      this.$emit('connect', connect)
    },

    wsSignature(message) {
      // 签名成功
      if (message.state === '1') {
        this.$emit('success', message.sign)
        return
      }
      // 签名失败
      if (message.state === '0') {
        this.$emit('error', message.msg)
        return
      }
    },
    // 打开签名板
    open() {
      this.$refs['wsSignatureRef'] && this.$refs['wsSignatureRef'].send({ apuType: 'HWSIGN', operate: 'open' })
    },
    // 检查中卫信设备通信服务运行状态
    check() {
      this.$refs['wsSignatureRef'] && this.$refs['wsSignatureRef'].check()
    }
  },
  beforeDestroy() {}
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
